const LAYOUT_COMPONENT_PARAGRAPH_PROPS = {
    testId: 'loading-paragraph',
  },
  LAYOUT_COMPONENT_TITLE_PROPS = {
    showBuilder: false,
    testId: 'loading-title',
  };

export { LAYOUT_COMPONENT_PARAGRAPH_PROPS, LAYOUT_COMPONENT_TITLE_PROPS };
